import {
  differenceInCalendarDays,
  format,
  startOfDay,
  subDays,
} from "date-fns";

export function inclusiveDays(range) {
  if (!range?.from || !range?.to) return 0;
  return differenceInCalendarDays(range.to, range.from) + 1;
}

export function formatRange(range) {
  if (!range?.from || !range?.to) return "Choose date range";
  if (range.from.getFullYear() === range.to.getFullYear()) {
    if (range.from.getMonth() === range.to.getMonth()) {
      return `${format(range.from, "d")} – ${format(range.to, "d MMM yyyy")}`;
    }
    return `${format(range.from, "d MMM")} – ${format(range.to, "d MMM yyyy")}`;
  }
  return `${format(range.from, "d MMM yyyy")} – ${format(range.to, "d MMM yyyy")}`;
}

export function presetRange(days) {
  const to = startOfDay(new Date());
  return {
    from: subDays(to, days - 1),
    to,
  };
}
